import React, {useEffect, useState} from 'react'
import {getResource, uploadFileResource} from "../../service/http-service";
import './ProfileFormsStyle.css'
import FormHeader from '../../../assets/img/profile-images/form-header.png'

export const ProfileImageForm = ({entityTemp,setEntityTemp,title,updateEntity,
                                     setUpdateEntity, setAddEntity}) => {

    const [entity, setEntity] = useState()
    const [selectedFile, setSelectedFile] = useState();
    const [isFilePicked, setIsFilePicked] = useState(false);
    const [showError, setShowError] = useState(false)
    const [backError, setBackError] = useState('Прикачената слика ја надминува дозволената големина од 5 MB')

    const changeHandler = (event) => {
        setSelectedFile(event.target.files[0]);
        setIsFilePicked(true);
        setShowError(false)
    };

    const handleSubmission = () => {
        let formData = new FormData();
        formData.append("file", selectedFile);

        if(entityTemp.id){
            formData.append("entityId", entityTemp.id);
        }else{
            formData.append("entityId", 0);
        }

        formData.append("candidateId", entityTemp.candidate.id);

        for (let key of formData.entries()) {
            console.log(key[0] + ', ' + key[1]);
        }
        uploadFileResource('candidates/add_candidate_image', formData).then((data) => {
            console.log(data.data)
            setShowError(false)
            setAddEntity(false)
            setUpdateEntity(!updateEntity)
            setEntityTemp({candidate: entityTemp.candidate})
        }).catch((exception) => {
            console.log(exception)
            setShowError(true)
        })

    };

    const addImage = () => {
        let fileInput = document.getElementById('fileInput');
        let fileDisplayArea = document.getElementById('fileDisplayArea');


        fileInput.addEventListener('change', function (e) {
            let file = fileInput.files[0];
            let imageType = /image.*/;

            if (file.type.match(imageType)) {
                let reader = new FileReader();
                reader.onload = function (e) {
                    fileDisplayArea.innerHTML = "";
                    let img = new Image();
                    img.src = reader.result;
                    fileDisplayArea.appendChild(img);
                }
                reader.readAsDataURL(file);
            } else {
                fileDisplayArea.innerHTML = "File not supported!"
            }
        });
    }




    useEffect (() => {
        setEntity(entityTemp)
    }, []);


    return (

            <div className="background-form col-12 p-0">
                {(entity) && (<>
                        <img src={FormHeader} className="form-header-image"/>
                        <div className="profile_add_button form-button-title">{title}</div>
                        <form id="newDocForm" className="col-lg-10 offset-lg-1">
                            <input id="fileInput"
                                   className="input-form w-100 mt-3"
                                   type="file" name="file"
                                   formtype="multipart/form-data"
                                   onChange={(e) => changeHandler(e)}
                                   onClick={() => addImage()}/>
                            <div id="fileDisplayArea"></div>
                            {showError && <small>{backError}</small>}
                            <div className="d-flex justify-content-between">
                                <div className="btn-form"
                                    onClick={() => {
                                        setAddEntity(false)
                                        setEntityTemp({candidate: entity.candidate})
                                    }}
                                >Затвори
                                </div>
                                <div
                                    type='button'
                                    className="btn-form"
                                    onClick={(e) => handleSubmission()}
                                >Зачувај
                                </div>
                            </div>
                        </form>
                    </>
            )
                }
        </div>
    )
}